/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { Palette } from 'config';

export const LabelBox = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  justify-content: space-between;
  width: 100%;
`;

export const DeleteBtn = styled.button`
  position: absolute;
  z-index: 90;
  right: 0;
  top: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 6px;
  background: #ffffff;
  border: none;
  border-radius: 0 4px 0 4px;
  outline: none;
  cursor: pointer;
  svg {
    fill: ${() => Palette.PrimaryGray._400};
  }
  &:hover {
    border: 1px solid ${() => Palette.PrimaryGray._300};
  }
  &:active,
  &:focus {
    border: 1px solid ${() => Palette.Primary._300};
    box-shadow: inset 0px 0px 0px 2px rgba(59, 137, 246, 0.16),
      inset 0px 2px 4px rgba(0, 0, 0, 0.04);
  }
`;

export const ImageContainer = styled.div`
  background-color: #f8fafc;
  align-items: center;
  justify-content: center;
  display: flex;
  padding: 8px;
  width: 100%;
  height: 160px;
  border-radius: 4px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04) inset;
`;

export const GridContainer = styled.div`
  height: fit-content;
  display: grid;
  /* grid-template-columns: 405px 405px; */
  grid-template-columns: 220px 1fr;
  margin-top: 32px;
  column-gap: 24px;
  row-gap: 106px;
`;

export const IconBox = styled.div`
  position: relative;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
`;

export const IconWrap = styled.div`
  border: 8px solid white;
  border-radius: 4px;
  height: 144px;
`;

export const WrapForError = styled.div`
  height: 190px;
`;
